import { TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import eye from "../../../assets/DigitalMarketing/image/visibility.svg";
import IosSwitchBtn from "../../../Component/DigitalMarketing/IosSwitchbtn";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import {
  useDeleteConsultantMutation,
  useUpdateConsultantStatusMutation,
} from "../../../Service/consultant";
import { Link } from "react-router-dom";

const TableLists = (props) => {
  const { consultantData, setShow, setUpdateData, setView, refetch } = props;
  const [deleteConsultant] = useDeleteConsultantMutation();
  const [updateConsultantStatus] = useUpdateConsultantStatusMutation();
  const { open, message, openDelete, deleteId } = useDeleteBox();
  const [checkedStates, setCheckedStates] = useState([]);

  const handleChange = (index: any, id: number) => (event) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = event?.target?.checked;
    setCheckedStates(newCheckedStates);

    updateStatus(id, event.target.checked);
  };

  const updateStatus = async (id, status) => {
    await updateConsultantStatus({ id, activeStatus: status ? "1" : "0" });
    refetch();
  };

  const handleUpdate = (data) => {
    // setView(false);
    setShow(true);
    setUpdateData(data);
  };

  const handleView = (data) => {
    // setView(true);
    // setShow(true);
    // setUpdateData(data);
  };

  const deleteBranches = async (bool) => {
    if (bool) {
      await deleteConsultant(deleteId);
      refetch();
    }
    openDelete("Are you sure you want to delete this Procedure?", false, null);
  };

  useEffect(() => {
    if (consultantData?.data) {
      setCheckedStates(consultantData.data.map((c) => c?.activeStatus === 1));
    }
  }, [consultantData]);

  return (
    <>
      <AlertDialog
        open={open}
        message={message}
        deleteBranches={deleteBranches}
      />
      {consultantData?.data?.length > 0 ? (
        consultantData.data.map((c, index) => (
          <TableRow key={c.id} role="checkbox">
            <TableCell align="left">{index + 1}</TableCell>
            <TableCell align="left">{c.consultantName}</TableCell>
            <TableCell align="left">{c.startDate}</TableCell>
            <TableCell align="left">{c.endDate}</TableCell>
            <TableCell align="left">{c.totalAmount}</TableCell>
            <TableCell align="left">{c.totalAppointment}</TableCell>
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={7} align="center">
            No data available
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default TableLists;
